"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-muted animate-pulse" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-default text-base text-foreground hover:text-foreground/80 transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const compoundLinks = [{
  label: "AI Ethics",
  to: "#"
}];
const bottomLinks = [{
  label: "PRIVACY",
  to: "/PrivacyPolicyPage"
}, {
  label: "TERMS",
  to: "/TermsOfServicePage"
}, {
  label: "ACCESSIBILITY",
  to: "/AccessibilityPage"
}];
export default function Footer() {
  return <section data-section-id="5012" id="footer" className="relative bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border" />

      <div className="pt-32 md:pt-40 pb-12 px-6 md:px-12 lg:px-16">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-10 max-w-[1600px] mx-auto">
          {}
          <div className="lg:col-span-2 space-y-8">
            <Link to="/" className="inline-block">
              <span className="text-5xl tracking-tighter leading-none !font-mono !font-black !italic md:text-6xl text-foreground" style={{
              letterSpacing: "-0.05em"
            }}>AutolexaAi</span>
            </Link>

            <p className="font-default text-lg md:text-xl text-foreground/80 leading-relaxed max-w-md">
              Architecting autonomous operations for the modern enterprise.
            </p>

            <div className="max-w-md pt-4">
              <div className="relative flex items-center border-b border-border pb-2">
                <Input type="email" placeholder="SUBSCRIBE FOR AI INSIGHTS" className="font-mono uppercase text-xs tracking-wider bg-transparent border-0 px-0 h-10 text-foreground placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-0" />
                <Button variant="ghost" size="icon" className="shrink-0 h-10 w-10 text-foreground/70 hover:text-foreground/80 hover:bg-transparent" aria-label="Subscribe">
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-5">
            <div>
              <h3 className="font-default font-bold uppercase text-xs tracking-widest text-foreground/70 mb-3">
                NAVIGATE
              </h3>
              <div className="h-px bg-border w-full" />
            </div>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-5">
            <div>
              <h3 className="font-default font-bold uppercase text-xs tracking-widest text-foreground/70 mb-3">
                AGENCY
              </h3>
              <div className="h-px bg-border w-full" />
            </div>
            <ul className="space-y-3">
              {compoundLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="font-default text-base text-foreground hover:text-foreground/80 transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-5">
            <div>
              <h3 className="font-default font-bold uppercase text-xs tracking-widest text-foreground/70 mb-3">
                CONTACT
              </h3>
              <div className="h-px bg-border w-full" />
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-2">
                <address className="font-default not-italic text-base text-foreground leading-relaxed">
                  44 Kerferd St
                  <br />
                  Rochester, VIC 3561 Australia
                </address>
              </div>

              <div>
                <Link to="tel:+61468075702" className="font-default text-base text-foreground hover:opacity-80 transition-opacity">
                  0468 075 702
                </Link>
              </div>

              <div>
                <Link to="mailto:info@autolexaai.com" className="font-default text-base text-foreground hover:text-foreground/80 transition-colors duration-300 break-all">
                  info@autolexaai.com
                </Link>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="h-px bg-border w-full mt-20 mb-8 max-w-[1600px] mx-auto" />

        {}
        <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono uppercase text-[11px] tracking-widest text-muted-foreground">
          <p className="!text-[rgba(255,251,250,1)]">© 2025 AUTOLEXAAI PTY LTD</p>

          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {bottomLinks.map((item, i) => <Link key={item.label} to={item.to} data-index={i} className="transition-colors duration-300 !text-[rgba(255,255,255,1)] hover:text-foreground/80">
                {item.label}
              </Link>)}
          </div>

          <p className="!text-[rgba(255,255,255,1)]">ENGINEERED IN AUSTRALIA</p>
        </div>
      </div>
    </section>;
}